import { PageHeader } from '@fukuri-admins/ui/common';

type Props = {
  fullName: string;
  indexHref: string;
};

/**
 * 利用者詳細ヘッダーの Presentation コンポーネント
 * パンくずリスト付きページヘッダーを表示する
 */
export const UserDetailHeaderPresentation: React.FC<Props> = ({ fullName, indexHref }) => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[{ label: '利用者', href: indexHref }, { label: fullName }]}
  />
);
